import React from 'react';

const Blogs = () => {
    return (
        <div className='py-20' id='blogs'>
            <div className='mb-2'>
                <h3 className='text-center text-2xl uppercase font-semibold text-green-500'
                    data-aos="fade-down"
                    data-aos-duration="800"
                >My Article</h3>
                <h3 className='text-center text-3xl font-semibold py-2'
                    data-aos="fade-down"
                    data-aos-duration="1000"
                >LATEST BLOGS</h3>
            </div>
            <h2 className='text-center text-2xl text-primary font-bold'>Comming Soon...</h2>
        </div>
    );
};

export default Blogs;